module.exports = __webpack_public_path__ + "static/flags/LH-5d4e05f67b7cbb7d5672a8ac7ca41498.gif";